// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"yq-z","slideIn":"zq-z"};